/**
 * Detects if form data has changed by comparing current form data with original data
 * @param {Object} currentFormData - Current form values
 * @param {Object} originalFormData - Original form values to compare against
 * @param {boolean} isDirty - React Hook Form's isDirty flag
 * @returns {boolean} - Whether the form has changes
 */
export const detectFormChanges = (currentFormData, originalFormData, isDirty) => {
  if (!originalFormData) return isDirty

  const originalActivities = originalFormData.activities || []
  const currentActivities = currentFormData.activities || []
  
  const activitiesChanged = 
    originalActivities.length !== currentActivities.length ||
    originalActivities.some((origActivity, index) => {
      const currActivity = currentActivities[index]
      return !currActivity ||
        origActivity.activityID !== currActivity.activityID ||
        origActivity.multiplier !== currActivity.multiplier
    })
  
  const contentChanged = Object.keys(currentFormData.content || {}).some(lang => {
    const origContent = originalFormData.content?.[lang] || {}
    const currContent = currentFormData.content[lang] || {}
    return Object.keys(currContent).some(key => 
      origContent[key] !== currContent[key]
    )
  })
  
  return activitiesChanged || contentChanged || isDirty
}